import Keycloak from "keycloak-js";
import config from "../config";

const keycloak = new Keycloak({
  url: "https://login.dijkgraaf-support.nl",
  realm: config.openIdRealm,
  clientId: config.openIdClient,
});
export default keycloak;
